import { useState } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid, List, ListItem, ListItemText, ListSubheader, ListItemIcon, Divider, Snackbar, Box, Pagination
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function CityAffectationConfirmationPopUp({ territoireName, listAffectation, listSuppression, opened, setOpened, setValidated }) {

  const [snackBarOpen, setSnackBarOpen] = useState(false);

  const itemsPerPage = 10;

  const [pageAffectation, setPageAffectation] = useState(1);
  const [noOfPagesAffectation] = useState(
    Math.ceil(listAffectation.length / itemsPerPage)
  );
  const handleChangePageAffectation = (event, value) => {
    setPageAffectation(value);
  };
  const [pageSuppression, setPageSuppression] = useState(1);
  const [noOfPagesSuppression] = useState(
    Math.ceil(listSuppression.length / itemsPerPage)
  );
  const handleChangePageSuppression = (event, value) => {
    setPageSuppression(value);
  };

  const handleClose = () => {
    setOpened(false);
    setSnackBarOpen(true);
    setValidated(true);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth='lg'
        open={opened}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Résumer des changements a appliqués pour "}<u>{territoireName}</u></DialogTitle>
        <DialogContent>

          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
            spacing={2} >
            <Grid item>
              {(listSuppression.length > 0 && listAffectation.length > 0) ? <Divider orientation="vertical" /> : null}
              {listSuppression.length > 0 ?
                <>
                  <List>
                    <ListSubheader component="div" id="nested-list-subheader">
                      Liste des villes à supprimer
                    </ListSubheader>
                    {listSuppression.slice((pageSuppression - 1) * itemsPerPage, pageSuppression * itemsPerPage).map((city) => (

                      <ListItem disablePadding key={city.id}>
                        <ListItemIcon>
                          <Iconify icon={'material-symbols:indeterminate-check-box'} color={'red'} style={{ marginRight: '10px' }} />
                        </ListItemIcon>
                        <ListItemText primary={city.name + " (" + city.insee_code + ")"}/>
                      </ListItem>
                    ))}
                  </List >
                  {noOfPagesSuppression > 1 ?
                    <>
                      <Divider />
                      <Box component="span">
                        <Pagination
                          count={noOfPagesSuppression}
                          page={pageSuppression}
                          onChange={handleChangePageSuppression}
                          defaultPage={1}
                          color="primary"
                          showFirstButton
                          showLastButton
                        />
                      </Box>
                    </>
                    : null
                  }
                </>
                : null
              }
            </Grid>
            <Grid item>
              {listAffectation.length > 0 ?
                <>
                  <List>
                    <ListSubheader component="div" id="nested-list-subheader">
                      Liste des villes à affecter
                    </ListSubheader>
                    {listAffectation.slice((pageAffectation - 1) * itemsPerPage, pageAffectation * itemsPerPage).map((city) => (
                      <ListItem disablePadding key={city.id}>
                        <ListItemIcon>
                          <Iconify icon={'material-symbols:add-box'} color={'blue'} style={{ marginRight: '10px' }} />
                        </ListItemIcon>
                        <ListItemText primary={city.name + " (" + city.insee_code + ")"} />
                      </ListItem>
                    ))}
                  </List>
                  {noOfPagesAffectation > 1 ?
                    <>
                      <Divider />
                      <Box component="span">
                        <Pagination
                          count={noOfPagesAffectation}
                          page={pageAffectation}
                          onChange={handleChangePageAffectation}
                          defaultPage={1}
                          color="primary"
                          showFirstButton
                          showLastButton
                        />
                      </Box>
                    </>
                    : null
                  }
                </>
                : null
              }
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          Êtes-vous sûr des changements ?
          <Button onClick={handleClose}>Valider</Button>
          <Button onClick={() => { setOpened(false) }} color={'error'}>Annuler</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackBarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackBarOpen(false)}
        message="Changement sauvegardé"
      />
    </>
  );
}